module.exports = __webpack_public_path__ + "img/task_flow_item_bg.08bb6f39.png";